var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconFlagCzech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.17 12.011L1.541 19.594c.577.415 1.312.657 2.209.657h16.5c2.485 0 3.75-1.846 3.75-4.125v-4.125H12.156l.014.01",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75c-.825 0-1.515.207-2.068.563L12.156 12H24V7.875c0-2.278-1.265-4.125-3.75-4.125z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.156 12L1.682 4.312C.567 5.029 0 6.354 0 7.876v8.25c0 1.456.52 2.733 1.541 3.467l10.63-7.582-.015-.01z",
    fill: "#1B75BB"
  })));
}

export default SvgIconFlagCzech;